module.exports = __webpack_public_path__ + "img/logo-grand-union.7f04064c.svg";